/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TenderAuctionTypes = 'SingleOffer' | 'OfferRounds' | 'OfferRoundsDynamicHidden' | 'ReverseAuction';

export const TenderAuctionTypes = {
    SingleOffer: 'SingleOffer' as TenderAuctionTypes,
    OfferRounds: 'OfferRounds' as TenderAuctionTypes,
    OfferRoundsDynamicHidden: 'OfferRoundsDynamicHidden' as TenderAuctionTypes,
    ReverseAuction: 'ReverseAuction' as TenderAuctionTypes
};

